import { contractsUrl } from '@/constant';
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'CreatedIframe',
})
export default class CreatedIframe extends Vue {
  /** 当前创建的iframe名称 */
  protected currentIframeEle = '';

  /** 当前创建的iframe父面板元素 */
  protected fatherIframe:HTMLElement | null = null;

  /**
   * 动态创建和替换iframe标签
   * */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public createdIframe(
    url: string,
    currentIframeEle: string,
    alreadyIframeEle: string,
    className: string,
  ) {
    const alreadyIframe = document.getElementById(currentIframeEle);
    this.currentIframeEle = currentIframeEle;
    const fatherIframe = document.getElementById(alreadyIframeEle);
    this.fatherIframe = fatherIframe;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('seamless', 'seamless');
    iframe.id = currentIframeEle;
    iframe.className = className;
    const _url = /pdf/g.test(url) ? `${contractsUrl}?pdf_url=${url}` : url;
    iframe.src = _url;
    if (fatherIframe) {
      if (alreadyIframe) {
        fatherIframe.replaceChild(iframe, alreadyIframe);
      } else {
        fatherIframe.appendChild(iframe);
      }
    }
  }

  /** 移除当前创建的iframe元素 */
  public removeIframe():void {
    if (this.fatherIframe) {
      const children = document.getElementById(this.currentIframeEle);
      if (children) {
        this.fatherIframe.removeChild(children as Node);
      }
    }
  }
}
